import React from "react";
/**
 * The context holding title metadata
 * @const
 * @type {React.Context<{function(title:string):void}>}
 * title: title of the page content
 */
export const PAGE_TITLE_CONTEXT: React.Context<{
  setPageTitle: (title: string) => void;
}> = React.createContext({
  // tslint:disable-next-line: no-empty
  setPageTitle: (title: string) => {},
});
